import MessageBox from '../message-box';
import style from './style.module.scss';

interface MessageBoxSetProps extends React.HTMLAttributes<HTMLElement> {
	infoText: string;
	warningText: string;
}

export default function MessageBoxSet({ infoText, warningText, className, ...props }: MessageBoxSetProps) {
	return infoText || warningText ? (
		<aside {...props} className={[style.boxes, className].join(' ')}>
			{infoText && <MessageBox type='info'>{infoText}</MessageBox>}
			{warningText && <MessageBox type='warning'>{warningText}</MessageBox>}
		</aside>
	) : null;
}
